module.exports = __webpack_public_path__ + "static/brand14-2aeabb1bc19a831095aaaded5f44c532.png";